// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2U0pf","content":"ManualTimeModal_content__KhyQu"};